import { render, staticRenderFns } from "./SubjectTypes.vue?vue&type=template&id=4b4b21e0&"
import script from "./SubjectTypes.vue?vue&type=script&lang=js&"
export * from "./SubjectTypes.vue?vue&type=script&lang=js&"
import style0 from "./SubjectTypes.vue?vue&type=style&index=0&id=4b4b21e0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports